(function () {
    "use strict";

    angular
        .module("app")
        .directive("criticalPathDevPrototypeList", ["CriticalPathService", criticalPathDevPrototypeList]);

    function criticalPathDevPrototypeList(criticalPathService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.loadData = function (id) {
                    if (!id) {
                        scope.data = [];
                        return;
                    }
                    criticalPathService.getDevPrototype(id).then(function (response) {
                        scope.data = response ? [response] : [];
                    });
                }

                scope.loadData(scope.devPrototypeId);

                scope.$watch("devPrototypeId", function (newValue, oldValue) {
                    if (newValue !== oldValue)
                        scope.loadData(newValue);
                });

                scope.$watch("updateDirectives", function (newValue) {
                    if (typeof newValue === "undefined")
                        return;
                    scope.loadData(scope.devPrototypeId);
                });
            },
            scope: { devPrototypeId: "=", updateDirectives: "=", prototypeSeasonalId: "=?" },
            templateUrl: templateUrl("app/components/criticalPath/devPrototypeList.directive.html")
        };
    }
})();

